export default __webpack_public_path__ + "static/media/img21.a85f1feb.jpg";